import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useBranch } from '@/features/branch/branch-context';
import { api } from '@/lib/api';
import type { VisitRatingList } from './types';

function useBranchKey() {
  const { selected, canSelectAll } = useBranch();
  return selected?.id ?? (canSelectAll ? 'all' : 'none');
}

/**
 * GET /visit-ratings?low: the branch's (or, with "All", every branch of the
 * role's) service ratings of the last 90 days, with the averages.
 */
export function useVisitRatings(low: boolean) {
  const branch = useBranchKey();
  return useQuery({
    queryKey: ['visit-ratings', branch, low],
    queryFn: async ({ signal }) =>
      (
        await api.get<VisitRatingList>('/visit-ratings', {
          signal,
          query: { low: low ? 'true' : undefined },
        })
      ).data,
    enabled: branch !== 'none',
    placeholderData: keepPreviousData,
  });
}
